import { IRedirectConfigState, IRedirect, clone, EModalType, IRedirectCandidate, PropertyHelper } from '../../helpers/';
import types from '../types';

export const initialState: IRedirectConfigState = {
    redirect: null,
    componentId: null,
    term: "",
    redirectCandidateResults: [],
    selectedCandidate: null,
    awaitingResults: false
};

const redirectConfigReducer = function(state:IRedirectConfigState = initialState, action): IRedirectConfigState {

	let stateClone:IRedirectConfigState = clone(state);

	switch(action.type) {

        case types.SET_REDIRECT_CANDIDATE_SEARCH:
            stateClone = setRedirectCandidateSearch(stateClone, action.term, action.redirectCandidateResults, action.awaitingResults);
            break;
        
        case types.SET_SELECTED_REDIRECT_CANDIDATE:
            stateClone = setSelectedRedirectCandidate(stateClone, action.selectedCandidate);
            break;

        case types.UPDATE_REDIRECT_DIALOG:
            stateClone = updateRedirectDialog(stateClone, action.redirect);
            break;

        case types.TOGGLE_DIALOG:
            stateClone = toggleDialog(stateClone, action.openModal, action.componentId, action.redirect);
            break;

	}

	return stateClone;

};

let setRedirectCandidateSearch = (state: IRedirectConfigState, term: string, redirectCandidateResults: IRedirectCandidate[], awaitingResults: boolean): IRedirectConfigState => {

    state.term = term;
    state.redirectCandidateResults = redirectCandidateResults;
    state.awaitingResults = awaitingResults;
    return state;
}

let setSelectedRedirectCandidate = (state: IRedirectConfigState, selectedCandidate: IRedirectCandidate): IRedirectConfigState => {
    state.selectedCandidate = selectedCandidate;
    return state;
}

let updateRedirectDialog = (state:IRedirectConfigState, redirect: IRedirect): IRedirectConfigState => {
    
    state.redirect = redirect;
    return state;
}

let toggleDialog = (state:IRedirectConfigState, openModal:EModalType, componentId: string, redirect: IRedirect) => {

    if(openModal === EModalType.RedirectConfig) {
        state.redirect = redirect;
        state.componentId = componentId;
    }	

	return state;

};

export default redirectConfigReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/redirect-config.ts